<template>
  <div class="semi-circle-progress">
    <div class="progress-wrapper">
      <!-- 扩大SVG的viewBox，为边缘元素留出空间 -->
      <svg width="400" height="220" viewBox="0 0 320 170">
        <!-- 背景轨道 -->
        <path d="M 60,150 A 100,100 0 0 1 260,150" fill="none" stroke="#e0e0e0" stroke-width="12"
          stroke-linecap="round" />

        <!-- 内部渐变半圆 - 只在 value > 0 时显示 -->
        <defs>
          <linearGradient :id="`innerGradient-${uid}`" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#a8e6cf" />
            <stop offset="100%" stop-color="#56ab91" />
          </linearGradient>
        </defs>
        <path v-if="value > 0" d="M 60,150 A 100,100 0 0 1 260,150" fill="none" :stroke="`url(#innerGradient-${uid})`" stroke-width="8"
          stroke-linecap="round" :stroke-dasharray="innerStrokeDasharray" />

        <!-- 外部进度条 - 只在 value > 0 时显示 -->
        <defs>
          <linearGradient :id="`outerGradient-${uid}`" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" :stop-color="outerColorStart" />
            <stop offset="100%" :stop-color="outerColorEnd" />
          </linearGradient>
        </defs>
        <path v-if="value > 0" d="M 60,150 A 100,100 0 0 1 260,150" fill="none" :stroke="`url(#outerGradient-${uid})`" stroke-width="12"
          stroke-linecap="round" :stroke-dasharray="outerStrokeDasharray" />

        <!-- 圆形按钮 - 始终显示 -->
        <circle :cx="buttonPosition.x" :cy="buttonPosition.y" r="8" :fill="outerColorStart" stroke="white"
          stroke-width="5" class="no-drag" style="filter: drop-shadow(0 3px 5px rgba(0,0,0,0.3));" />

        <!-- 三角形和文字组 - 只在 value > 0 时显示 -->
        <g v-if="value > 0" :transform="`translate(${indicatorPosition.x}, ${indicatorPosition.y}) rotate(${buttonRotation + 180})`">
          <!-- 小三角形 -->
          <polygon points="0,-25 -6,-35 6,-35" class="triangle no-drag" :stroke="outerColorStart"
            style="filter: drop-shadow(0 2px 3px rgba(0,0,0,0.2));" />

          <!-- 百分比文字 -->
          <text y="-42" class="button-label no-drag" :fill="outerColorStart" style="font-size: 10px;">{{ value
          }}%</text>
        </g>
        
        <!-- 当 value = 0 时显示特殊标记 -->
        <g v-if="value === 0">
          <circle cx="60" cy="150" r="8" :fill="outerColorStart" stroke="white"
            stroke-width="5" class="no-drag" style="filter: drop-shadow(0 3px 5px rgba(0,0,0,0.3));" />
          <text x="60" y="145" class="button-label no-drag" :fill="outerColorStart" 
            text-anchor="middle" style="font-size: 10px;">0%</text>
        </g>
      </svg>
      <div class="progress-score">得分</div>
      <div class="progress-text flex FlexBaseline">
        <div>{{ score }}</div>
        <div class="progress_total">/{{totalScore}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemiCircleProgress',
  props: {
    value: {
      type: Number,
      default: 0,
      validator: (value) => {
        return value >= 0 && value <= 100
      }
    },
    label: {
      type: String,
      default: '当前进度'
    },
    score:{},
    totalScore:{},
    outerColorStart: {
      type: String,
      default: '#13D6AA'
    },
    outerColorEnd: {
      type: String,
      default: '#00f2fe'
    }
  },
  data() {
    return {
      uid: Math.random().toString(36).substring(2, 9)
    }
  },
  computed: {
    // 计算内部进度条的 stroke-dasharray
    innerStrokeDasharray() {
      if (this.value === 0) return '0, 314';
      return `${this.value * 314 / 100}, 314`;
    },
    // 计算外部进度条的 stroke-dasharray
    outerStrokeDasharray() {
      if (this.value === 0) return '0, 314';
      return `${this.value * 314 / 100}, 314`;
    },
    buttonPosition() {
      // 调整圆心坐标，为边缘留出空间
      const centerX = 160;
      const centerY = 150;
      const radius = 100;

      // 当 value = 0 时，强制将按钮放在最左侧
      if (this.value === 0) {
        return { x: 60, y: 150 };
      }

      const angle = Math.PI - (this.value / 100) * Math.PI;

      const x = centerX + radius * Math.cos(angle);
      const y = centerY - radius * Math.sin(angle);

      return { x, y };
    },
    indicatorPosition() {
      // 当 value = 0 时，不显示指示器
      if (this.value === 0) {
        return { x: 0, y: 0 };
      }
      
      const centerX = 160;
      const centerY = 150;
      const radius = 92;

      const angle = Math.PI - (this.value / 100) * Math.PI;

      const x = centerX + radius * Math.cos(angle);
      const y = centerY - radius * Math.sin(angle);

      return { x, y };
    },
    buttonRotation() {
      // 当 value = 0 时，不计算旋转
      if (this.value === 0) {
        return 0;
      }
      
      const centerX = 160;
      const centerY = 150;

      const indicatorX = this.indicatorPosition.x;
      const indicatorY = this.indicatorPosition.y;

      const dx = centerX - indicatorX;
      const dy = centerY - indicatorY;
      let angle = Math.atan2(dy, dx) * 180 / Math.PI;

      return angle + 90;
    }
  }
}
</script>

<style scoped>
/* 样式保持不变 */
.semi-circle-progress {
  display: inline-block;
  text-align: center;
}

.progress-wrapper {
  position: relative;
  width: 400px;
  height: 240px;
  margin: 0 auto;
}

.progress-score {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #909090;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.progress-text {
  position: absolute;
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  color: #303030;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.progress_total{
  font-size: 16px;
  color: #909090;
}

.progress-label {
  font-size: 1.4rem;
  color: #909090;
  margin-top: 10px;
}

.button-label {
  font-size: 0.7rem;
  font-weight: bold;
  text-anchor: middle;
  dominant-baseline: middle;
}

.triangle {
  fill: white;
  stroke-width: 2;
}

.no-drag {
  cursor: default;
  pointer-events: none;
}
</style>